import { render, staticRenderFns } from "./ValProductosView.vue?vue&type=template&id=53738af0&"
import script from "./ValProductosView.vue?vue&type=script&lang=js&"
export * from "./ValProductosView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports